import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/spain-provinces.geojson";

const REGIONS = [
    { code: "A Coruña", name: "A Coruña" },
    { code: "Alacant/Alicante", name: "Alacant/Alicante" },
    { code: "Albacete", name: "Albacete" },
    { code: "Almería", name: "Almería" },
    { code: "Araba/Álava", name: "Araba/Álava" },
    { code: "Asturias", name: "Asturias" },
    { code: "Badajoz", name: "Badajoz" },
    { code: "Barcelona", name: "Barcelona" },
    { code: "Bizkaia/Vizcaya", name: "Bizkaia/Vizcaya" },
    { code: "Burgos", name: "Burgos" },
    { code: "Cantabria", name: "Cantabria" },
    { code: "Castelló/Castellón", name: "Castelló/Castellón" },
    { code: "Ceuta", name: "Ceuta" },
    { code: "Ciudad Real", name: "Ciudad Real" },
    { code: "Cuenca", name: "Cuenca" },
    { code: "Cáceres", name: "Cáceres" },
    { code: "Cádiz", name: "Cádiz" },
    { code: "Córdoba", name: "Córdoba" },
    { code: "Gipuzkoa/Guipúzcoa", name: "Gipuzkoa/Guipúzcoa" },
    { code: "Girona", name: "Girona" },
    { code: "Granada", name: "Granada" },
    { code: "Guadalajara", name: "Guadalajara" },
    { code: "Huelva", name: "Huelva" },
    { code: "Huesca", name: "Huesca" },
    { code: "Illes Balears", name: "Illes Balears" },
    { code: "Jaén", name: "Jaén" },
    { code: "La Rioja", name: "La Rioja" },
    { code: "Las Palmas", name: "Las Palmas" },
    { code: "León", name: "León" },
    { code: "Lleida", name: "Lleida" },
    { code: "Lugo", name: "Lugo" },
    { code: "Madrid", name: "Madrid" },
    { code: "Melilla", name: "Melilla" },
    { code: "Murcia", name: "Murcia" },
    { code: "Málaga", name: "Málaga" },
    { code: "Navarra", name: "Navarra" },
    { code: "Ourense", name: "Ourense" },
    { code: "Palencia", name: "Palencia" },
    { code: "Pontevedra", name: "Pontevedra" },
    { code: "Salamanca", name: "Salamanca" },
    { code: "Santa Cruz De Tenerife", name: "Santa Cruz De Tenerife" },
    { code: "Segovia", name: "Segovia" },
    { code: "Sevilla", name: "Sevilla" },
    { code: "Soria", name: "Soria" },
    { code: "Tarragona", name: "Tarragona" },
    { code: "Teruel", name: "Teruel" },
    { code: "Toledo", name: "Toledo" },
    { code: "Valladolid", name: "Valladolid" },
    { code: "València/Valencia", name: "València/Valencia" },
    { code: "Zamora", name: "Zamora" },
    { code: "Zaragoza", name: "Zaragoza" },
    { code: "Ávila", name: "Ávila" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const SpainMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 1800, center: [-4, 40] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="spain"
            analyticsLocationType="spain"
            trackingLabel="Spain Map"
            storageKey="spain_map"
            title="🇪🇸 Spain Travel Map"
            subtitle="Click on Spanish provinces you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Provinces"
            unitLabel="provinces"
            captionUnit="Spanish provinces"
            share={{
                region: 'Spain',
                fileName: 'visited-spain-map.png',
                trackId: 'spain'
            }}
            renderMap={renderMap}
        />
    );
};

export default SpainMapSection;
